import styled from 'styled-components'
import { theme } from '../../../../../style/theme'
import { colorTheme } from '../../../../../style/theme/colorTheme'

export const InvoiceCustomerDataWrapper = styled.div`
	font-size: 1rem;
	display: flex;
	flex-direction: column;
	gap: 1.25em;
	margin-bottom: 0.63em;
`
InvoiceCustomerDataWrapper.displayName = 'InvoiceCustomerDataWrapper'

export const InvoiceCustomerDataSubtitle = styled.div`
	color: ${colorTheme.cartModal.invoiceModals.customerData.subtitle};
	font-family: ${theme.fontRobotoMedium};
	font-size: 1.13em;
	font-weight: 500;
`
InvoiceCustomerDataSubtitle.displayName = 'InvoiceCustomerDataSubtitle'

export const InvoiceCustomerDataDescription = styled.div`
	color: ${colorTheme.cartModal.invoiceModals.customerData.description};
	font-size: 1.06em;
	font-weight: 400;
`
InvoiceCustomerDataDescription.displayName = 'InvoiceCustomerDataDescription'

export const InvoiceBillingAddressWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.63em;
	text-align: left;

	@media screen and (max-width: ${theme.point820}) {
		grid-column: 1 / 3;
	}

	@media screen and (max-width: ${theme.point720}) {
		grid-column: 1;
	}
`
InvoiceBillingAddressWrapper.displayName = 'InvoiceBillingAddressWrapper'

export const InvoiceBillingAddressBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.63em;
	padding-top: 0.63em;
	border-top: 1px solid ${colorTheme.cartModal.invoiceModals.customerData.billingAddress.border};
`
InvoiceBillingAddressBlock.displayName = 'InvoiceBillingAddressBlock'

export const InvoiceBillingAddressSource = styled.div`
	color: ${colorTheme.cartModal.invoiceModals.customerData.billingAddress.source};
	font-size: 0.88em;
	font-weight: 400;
`
InvoiceBillingAddressSource.displayName = 'InvoiceBillingAddressSource'

export const InvoiceBillingAddressRecipient = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 0.63em;

	@media screen and (max-width: ${theme.point720}) {
		grid-template-columns: 1fr;
	}
`
InvoiceBillingAddressRecipient.displayName = 'InvoiceBillingAddressRecipient'
